$ = require 'jquery'
Browser = require '@trello/browser'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
TrelloClipboard = require 'lib/trello-clipboard'
Util = require 'lib/util'
_ = require 'underscore'
log = require 'debug/log'
track = require 'debug/track'
{ getTypes, getPasted } = require 'views/internal/data-transfer/normalize'
triggerList = require 'lib/util/event/trigger-list'
f = require 'effing'

module.exports = UserInput = new class
  constructor: ->
    @_handlers = {}

    @clear()
    for event in ['keydown', 'keypress', 'paste']
      $(document).on event, @[event].bind(@)

    TrelloClipboard.on 'pasteImage', (image) =>
      @triggerPasted('files', [image])

  precedence:
    global: 0
    default: 1
    header: 2
    board: 3
    board_sidebar: 3
    list: 4
    card: 5
    search_box: 6
    power_ups_directory: 8
    dialog: 10
    dialog_view: 12
    plugin_modal: 20
    popover: 30
    popover_view: 32
    attachment_viewer: 100
    quick_card_editor: 100

  _isKeyEligible: (e) ->
    # No shortcuts if ...
    # - Touch device
    # - If they're typing in an input or have a select highlighted
    #   (An exception is made for Esc)
    # - There is some modifier key being used
    key = Keyboard.getKey(e)
    !((Browser.isTouch()) ||
      (key == Keys.Unknown) ||
      (key != Keys.Escape &&
        $(e.target).is('input:visible,textarea:visible,select:visible')) ||
      (e.ctrlKey || e.altKey || e.metaKey))

  addHandler: (target, { scope, precedence, modal }) ->
    precedence ?= @precedence[scope]
    if !precedence?
      log('userinput', "Missing precedence for #{ scope }")
      precedence = @precedence.default

    modal ?= false

    @_handlers[scope] ?= {}
    @_handlers[scope] = {
      target
      scope
      precedence
      modal
    }

    log('userinput', "Adding handler for #{ scope }")

  isModalPresent: ->
    for scope, { modal } of @_handlers when modal == true
      return true
    return false

  removeHandlerScope: (localScope) ->
    for scope of @_handlers when scope == localScope
      log('userinput', "Removing handlers for #{ scope }")
      delete @_handlers[scope]

  removeHandler: (target) ->
    for scope, { target: hTarget } of @_handlers when target == hTarget
      log('userinput', "Removing handler for #{ scope }")
      delete @_handlers[scope]

  clear: ->
    log('userinput', "Removing all non-global handlers")
    for scope of @_handlers when scope != 'global'
      log('userinput', "Removing handler for #{ scope }")
      delete @_handlers[scope]

  inclusiveTakeUntil = (list, pred) ->
    results = []
    for item in list
      results.push item
      if pred(item)
        break
    results

  _sortedHandlers: ->
    handlers = _.sortBy(_.values(@_handlers), (h) -> -h.precedence)

    # The idea here being that if a modal is present, it's going to handle
    # everything: nothing lower-precedence than the modal can receive any
    # keyboard events. However, anything higher precedence than the modal
    # can still opt to receive the events, since it's probably contained
    # in the modal's content.
    inclusiveTakeUntil handlers, f.get('modal')

  _triggerOnTargets: (event, args...) ->
    for { target } in @_sortedHandlers()
      handled =
        if target?[event]?
          target[event](args...)
        else if target?.triggerHandler?
          target.triggerHandler(event, args)

      if handled
        if _.isString(handled) || _.isArray(handled)
          @_track(handled)
        return true

    false

  keydown: (e) ->
    # Firefox likes to abort AJAX requests when the ESC key is pressed
    # preventing the default action keeps it from doing this
    #
    # Safari will exit full screen mode when ESC is pressed; we don't want it
    # to do that, because people will pres ESC to close dialogs
    key = Keyboard.getKey(e)

    if key == Keys.Escape
      Util.stop(e)

    if @_isKeyEligible(e)
      if @_triggerOnTargets 'shortcut', key, e
        Util.stop(e)

    return

  keypress: (e) ->
    key = Keyboard.getKey(e)

    if @_isKeyEligible(e)
      if @_triggerOnTargets 'shortcut', key, e
        Util.stop(e)

    return


  paste: (e) ->
    getPasted(e.originalEvent).then (pasted) =>
      if _.isEmpty(pasted)
        return

      if (pasted.text || pasted.url) && e.target.tagName in ['INPUT', 'TEXTAREA']
        # If they're pasting text into an input of some kind, just let the
        # default handling happen … unless it's the trello clipboard trying to
        # intercept the paste, in which case it's okay to handle it
        if !TrelloClipboard.isClipboard(e.target)
          return

      # Some applications (like PowerPoint and OneNote) will put several
      # different types on the clipboard when you copy. If there is some text,
      # assume they want that (and not a picture of the text).
      for type in ['url', 'text', 'files'] when pasted[type]
        @triggerPasted(type, pasted[type])
        break

      return

    return

  triggerPasted: (type, detail) ->
    elements = _.compact(@_sortedHandlers().map (handler) -> handler.target?.el)
    triggerList elements, "userinput-paste:#{ type }", { detail }

  _track: (trackName) ->
    if trackName?
      if !_.isArray(trackName)
        trackName = [trackName]
      track("Keyboard Shortcuts", trackName...)



// WEBPACK FOOTER //
// ./app/scripts/views/internal/user-input.coffee